import {Component, Input} from '@angular/core';
import { CommonModule, DatePipe } from "@angular/common";
import {AuditEvent, auditFriendlyName} from '../../../core/models/audit/audit-event.model';
import {formatElapsed} from '../../../core/helpers/date-timer.helper';
import {BadgeComponent} from '../badge/badge.component';

@Component({
  selector: 'app-audit-event-display',
  imports: [
    DatePipe,
    CommonModule,
    BadgeComponent
  ],
  templateUrl: './audit-event-display.component.html',
  styleUrl: './audit-event-display.component.scss'
})
export class AuditEventDisplayComponent {

  @Input() events: AuditEvent[] = [];
  @Input() loading: boolean = false;

  protected readonly formatElapsed = formatElapsed;
  protected readonly auditFriendlyName = auditFriendlyName;
}
